import data from "../../../../../src/Flash.docs.json";
import * as React from 'react';
export default {
  data,
  React
};